import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import SelectComponent from "../../components/SelectComponent/SelectComponent";
import Addguest from "../ActivitiesWidget/Addguest";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import lang from "../../assets/lang.png";
import DateComponent from "../ActivitiesWidget/DateComponent";
import ReservationType from "../ActivitiesWidget/ReservationType";
import TimeComponent from "../ActivitiesWidget/TimeComponent";
import {
  setGuestCount,
  updateSelectedDate,
  updateTime,
  updateActivityDuration,
  updateReservationType,
  updateDefaultLanguage,
} from "../../store/slice/Activity.slice";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import calenderImg from "../../assets/CalendarAct.png";
import { checkGuestLimit } from "../../store/slice/Activity.slice";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import {
  calculateEndTime,
  convertToTimeFormat,
  formatName,
  format_Number,
} from "../../utils/utils";
import { Box, Button, useMediaQuery } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  setLanguageID,
  setLanguageWords,
  updateBlockedDates,
  setFreeTablesData,
  setExtraProductData,
  setIsOpenWidget,
  setCombinationList,
} from "../../store/slice/Activity.slice";
import {
  FetchWidgetConfigDetails,
  GetGuestDetailsByKey,
  getExtraProductDetails,
  getLanguageDetails,
  getWidgetSettings,
  getWidgetTitleandInfo,
} from "../../api/HorecaWidget.service";
import {
  setLanguageLoaded,
  updateButtonText,
  updateGuestInfo,
  updateKey,
  updateLanguageData,
  updateWidgetConfig,
  updateWidgetSetting,
} from "../../store/slice/widgetSetting.slice";
import { useTranslation } from "react-i18next";
import {
  fetchActivitesTime,
  fetchActivities,
  fetchClosedActivityDates,
  getCombinationList,
} from "../../api/activity.service";
import {
  setActivityData,
  setActivityDataLoading,
  updateTotalCount,
} from "../../store/slice/Activity.slice";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing
let loadSettings = null;
let widgetIdSettings = null;

const ActivityComponent = ({ data,language,id}) => {
  const {widgetConfig,key } = useSelector(
    (store) => store?.widgetSettings
  );
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reservTypeLoading, setReserveTypeLoading] = useState(false);
  const [isAddGuest, setIsAddGuest] = useState(false);
  const guestRef = useRef(null);
  const dateRef = useRef(null);

  const reservationType = useRef(null);
  const timeRef = useRef(null);
  const activityDurationRef = useRef(null);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [isReservationType, setIsReservationType] = useState(false);
  const [isTimeComponent, setIsTimeComponent] = useState(false);
  const [isActivityDuration, setIsActivityDuration] = useState(false);
  const {
    totalCount,
    selectedDate,
    reservType,
    time,
    adult,
    defaultLanguage,
    isGreaterThan10,
    languageWords,
    activityDuration,
  } = useSelector((store) => store.Activity);
  const nonEmptyFields = Object.keys({})
    .filter(
      (key) =>
        key.startsWith("field") && widgetConfig?.fields[key].trim() !== ""
    )
    .map((key) => widgetConfig?.fields[key]);
  const { freeTablesData, child, baby, toddler, kid } = useSelector(
    (store) => store.Activity
  );
  const { widgetSetupId, buttonText, guestId } = useSelector(
    (store) => store?.widgetSettings
  );
  const { isOpenWidget } = useSelector((store) => store?.addGuest);
  const [loading, setLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const [langLoading, setLangLoading] = useState(false);
  const [widgetLoading, setWidgetLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const [openWidget, setOpenWidget] = useState(
    location?.state?.openWidgetScreen ?? isOpenWidget
  );
  const prevLang = useRef(language);
  const prevDate = useRef(selectedDate);
  const idReservTypeRef = useRef(reservType?.idreservationtype);
  const fetchLanguageDetails = async () => {
    setLangLoading(true);
    try {
      const response = await getLanguageDetails(data?.key);
      if (response?.status != 200) {
        console.error("Error fetching language details widget:", response);
        return;
      }
      dispatch(updateLanguageData(response?.data));
      const langParam = queryParams.get("lang");
      if (response?.data) {
        const defaultLang =
          !language && !langParam
            ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
            : langParam
            ? langParam
            : language;
        dispatch(updateDefaultLanguage(defaultLang));
        dispatch(setLanguageLoaded(true)); // Set the flag to true
        dispatch(setLanguageID(defaultLang?.idlanguage));
      }
      setLangLoading(false);
    } catch (error) {
      console.error("Error fetching language details widget:", error?.message);
      setLangLoading(false);
    }
  };
  const fetchWidgetSettings = async (language) => {
    setWidgetLoading(true);
    try {
      const response = await getWidgetSettings(language,data?.key);
      loadSettings = response;
      dispatch(updateWidgetSetting(response?.data));
      setWidgetLoading(false);
    } catch (error) {
      setWidgetLoading(false);
      console.error("Error fetching widget settings:", error?.message);
    }
  };
  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      setWidgetLoading(true);
      const response = await FetchWidgetConfigDetails(
        data?.key,
        data?.idWidgetSetup,
        lang,
        guestId
      );
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings details. Please try again later."
        );
      }
      const result = response?.data?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        const data = item.widgetTranslateLanguages[0]?.name;
        acc[tag] = data; // Assign data to the key acc[tag]
        return acc;
      }, {});
      dispatch(updateWidgetConfig(response?.data));
      dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
      dispatch(setLanguageWords(result));
      setWidgetLoading(false);
    } catch (error) {
      console.error("Error fetching widget settings details:", error);
      setWidgetLoading(false);
    }
  };
  const fetchGuestDetailsByToken = async () => {
    try {
      const response = await GetGuestDetailsByKey(
        widgetConfig?.token,
        data?.key,
        guestId
      );
      if (!response) {
        throw new Error(
          "Failed to fetch guest details. Please try again later."
        );
      }
      dispatch(updateGuestInfo(response));
    } catch (error) {
      console.error("Error fetching guest details by token:", error);
    }
  };
  const fetchWidgetTitleandInfo = async (widgetSetupId, language) => {
    try {
      const response = await getWidgetTitleandInfo(widgetSetupId, language);
      widgetIdSettings = response;
    } catch (error) {
      console.error("Error fetching widget settings:", error?.message);
    }
  };
  const getUnavailableCalenderDetails = async () => {
    if (freeTablesData?.length > 0) return;
    const response = await fetchClosedActivityDates(data?.key);
    if (response.success === false) {
      console.error(response.message); // Set the error message
    } else {
      dispatch(updateBlockedDates(response));
    }
    dispatch(setActivityDataLoading(false));
  };
  const getTimeDetails = async () => {
    const payload = {
      idwidgetsetup: widgetSetupId,
      key: key,
      date: dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      idreservationType: reservType?.idreservationtype,
      noOfGuest: parseInt(totalCount),
      durationTimeValue:
        activityDuration?.timeValue || reservType?.products[0]?.timeValue,
    };

    const response = await fetchActivitesTime(payload);
    if (response.success === false) {
      console.error(response.message); // Set the error message
    } else {
      dispatch(setFreeTablesData(response));
    }
  };
  const fetchExtraTicketProducts = async () => {
    try {
      const response = await getExtraProductDetails(
        reservType?.idreservationtype,
        language
      );
      if (response?.status == 200) {
        dispatch(setExtraProductData(response));
      }
    } catch (error) {
      console.log("error extra product", error?.message);
    }
  };

  const fetchCombinations = async () => {
    setLoading(true);
    dispatch(setCombinationList([]));
    const endTime = calculateEndTime(
      time,
      convertToTimeFormat(activityDuration?.name)
    );
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
    // Check if date is valid
    if (!parsedDate?.isValid()) {
      console.error("Invalid date:", selectedDate);
      return;
    }
    // Format the valid date into 'YYYY-MM-DD'
    const formattedDate = parsedDate.format("YYYY-MM-DD");
    const payload = {
      key: data?.key,
      idreservationtype: parseInt(reservType?.idreservationtype),
      ArrivalDate: formattedDate,
      ArrivalTime: time,
      DepatureTime: endTime,
      Field1: parseInt(adult),
      Field2: parseInt(child),
      Field3: parseInt(kid),
      Field4: parseInt(toddler),
      Field5: parseInt(baby),
      LanguageCode: language,
      NoOfGuest: parseInt(totalCount),
    };
    try {
      const response = await getCombinationList(payload);
      dispatch(setCombinationList(response));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(updateKey(data?.key));
  }, [data]);

  useEffect(() => {
    if (widgetConfig?.token) {
      fetchGuestDetailsByToken();
    }
  }, [widgetConfig]);
  useEffect(() => {
    if (time) fetchCombinations();
  }, [time]);

  useEffect(() => {
    if (Object?.keys(reservType)?.length > 0) {
      fetchExtraTicketProducts();
    }
  }, [reservType]);

  const getActivityDetails = useCallback(async () => {
    if (!selectedDate) return;
    const originalDate = dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    dispatch(setActivityDataLoading(true));
    const response = await fetchActivities(
      data?.key,
      language,
      data?.idWidgetSetup,
      originalDate,
      totalCount
    );
    if (response?.length > 0) {
      dispatch(setActivityData(response));
    } else {
      console.error(response.message); // Set the error message
    }
    dispatch(setActivityDataLoading(false));
  }, [language, selectedDate]); // Dependencies

  useEffect(() => {
    if (language) {
      // Checks if defaultLanguage is non-empty and has changed from the previous value
      fetchWidgetSettingsDetails(language);
    }
  }, [language]);

  useEffect(() => {
    fetchLanguageDetails();
  }, [data]);

  useEffect(() => {
    if (language ) {
      fetchWidgetSettings(language);
    }
  }, [language]);

  useEffect(() => {
    if (language) {
      fetchWidgetTitleandInfo(widgetSetupId, language);
   
    }
  }, [language]);

  useEffect(() => {
    getUnavailableCalenderDetails();
  }, [data?.key]);

  useEffect(() => {
    if (
      prevLang.current !== language ||
      prevDate.current !== selectedDate
    ) {
      getActivityDetails();
      prevLang.current = language; // Update ref to avoid unnecessary calls
      prevDate.current = selectedDate;
    }
  }, [language, selectedDate, getActivityDetails]);

    useEffect(() => {
      if (Object.keys(reservType)?.length > 0) {
        getTimeDetails();
      }
    }, [reservType]);
  

  useEffect(() => {
    dispatch(updateTotalCount(adult));
  }, [adult]);
  useEffect(() => {
    if (adult > 10) {
      dispatch(
        checkGuestLimit({
          guestType: "adult",
          isGreaterThan10: true,
        })
      );
    } else {
      dispatch(
        checkGuestLimit({
          guestType: "adult",
          isGreaterThan10: false,
        })
      );
    }
  }, [adult]);
  return (
    <Grid
      container
      spacing={2}
      sx={{ mb: 3 }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      {!nonEmptyFields ||
      nonEmptyFields.length == 1 ||
      nonEmptyFields.length == 0 ? (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl
            fullWidth
            sx={{
              width: "100%",
              height: "70px",

              position: "relative",
              backgroundColor: theme?.guest?.bgColor,
              // Remove border from the outlined input
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },

              // Ensure the input itself doesn't have a border
              "& .MuiInputBase-root": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
                boxShadow: "none",
              },

              // Remove border on focus
              "& .Mui-focused": {
                border: "none",
                boxShadow: "none",
              },
            }}
          >
            {isGreaterThan10?.adult ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: "0.1rem", sm: "0.2rem" },
                }}
              >
                <IconButton
                  aria-label="add-icon"
                  sx={{
                    color: theme?.guest?.textColor,
                    position: "absolute",
                    left: "3rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                  }}
                  onClick={(event) => {
                    event.stopPropagation(); // Prevent TextField click
                    if (adult > 1) {
                      //   resetReservationData();
                      dispatch(updateSelectedDate(""));
                      dispatch(updateReservationType({}));
                      dispatch(updateTime(""));
                      dispatch(updateActivityDuration(""));
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: adult - 1,
                        })
                      );
                    }
                  }}
                >
                  <RemoveCircleIcon />
                </IconButton>
                <Typography
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 20,
                    fontSize: "12px",
                    color: theme?.widget?.inputTextColor,
                    fontWeight: 200,
                  }}
                >
                  {languageWords?.Guest}
                </Typography>
                <TextField
                  sx={{
                    position: "relative",
                    height: "30px",
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: theme?.guest?.dropdownBorderColor,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: theme?.guest?.dropdownBorderColor,
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      textAlign: "center",
                      py: 3,
                      color: "#9F9F9F",
                    },
                  }}
                  placeholder="00"
                  name="adult"
                  value={adult}
                  disabled={true}
                />
                <IconButton
                  aria-label="add-icon"
                  sx={{
                    color: theme?.guest?.textColor,
                    position: "absolute",
                    right: "3rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                  }}
                  onClick={() => {
                    //  resetReservationData();
                    dispatch(updateSelectedDate(""));
                    dispatch(updateReservationType({}));
                    dispatch(updateTime(""));
                    dispatch(updateActivityDuration(""));
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: adult + 1,
                      })
                    );
                  }}
                >
                  <AddCircleIcon />
                </IconButton>
              </Box>
            ) : (
              <Box>
                <Typography
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 20,
                    fontSize: "12px",
                    color: theme?.widget?.inputTextColor,
                    fontWeight: 200,
                  }}
                >
                  {languageWords?.Guest}
                </Typography>
                <KeyboardArrowDownIcon
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                  }}
                />

                <Select
                  id="demo-simple-select"
                  value={adult}
                  fullWidth
                  // IconComponent={KeyboardArrowDownIcon}
                  IconComponent={null} // Remove the default arrow icon
                  sx={{
                    position: "relative",

                    width: "100%",
                    height: "72px",
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      color: theme?.guest?.textColor,
                      ml: 3,
                      mt: 1,
                      fontSize: { sm: "12px", md: "14px" },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none !important", // Remove default border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none !important", // Ensure no border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure no border on focus
                    },
                  }}
                  onChange={(event) => {
                    //  resetReservationData();
                    dispatch(updateSelectedDate(""));
                    dispatch(updateReservationType({}));
                    dispatch(updateTime(""));
                    dispatch(updateActivityDuration(""));
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: Number(event.target.value),
                      })
                    );
                  }}
                >
                  {new Array(10).fill(null).map((_, index) => (
                    <MenuItem
                      key={index}
                      value={index + 1}
                      sx={{
                        color: theme?.guest?.dropdownTextColor,
                        width: "100%",
                        fontSize: { sm: "12px", md: "1.2rem" },
                        "&:hover": {
                          backgroundColor: theme?.guest?.dropdownBgHover,
                          color: theme?.guest?.dropdownTextColorHover,
                        },
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    value={11}
                    sx={{
                      color: theme?.guest?.dropdownTextColor,
                      fontSize: { sm: "12px" },
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      dispatch(updateSelectedDate(""));
                      dispatch(updateReservationType({}));
                      dispatch(updateTime(""));
                      dispatch(updateActivityDuration(""));
                      dispatch(
                        checkGuestLimit({
                          guestType: "adult",
                          isGreaterThan10: true,
                        })
                      );
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: 11,
                        })
                      );
                    }}
                  >
                    <AddBoxTwoToneIcon
                      sx={{
                        color: theme?.guest?.plusColor,
                        width: { xs: 16, sm: 20 },
                        height: { xs: 16, sm: 20 },
                        "&:hover": {
                          color: theme?.guest?.plusHover,
                        },
                      }}
                    />
                  </MenuItem>
                </Select>
              </Box>
            )}
          </FormControl>
        </Grid>
      ) : (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectComponent
            label={languageWords?.Guest}
            value={totalCount}
            onClick={() => {
              setIsAddGuest(!isAddGuest);
            }}
            ref={guestRef}
          />
          <Addguest
            isOpen={isAddGuest}
            handleClose={() => setIsAddGuest(false)}
            Ref={guestRef.current}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.date}
          value={selectedDate?.trim() != "" ? selectedDate : "DD-MM-YYYY"}
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
          onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
          ref={dateRef}
          icon={calenderImg}
          isIcon={true}
          disabled={totalCount > 0 ? false : true}
        />
        <DateComponent
          isOpen={isDateDropdownOpen}
          handleClose={() => setIsDateDropdownOpen(false)}
          Ref={dateRef.current}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.reserveType}
          value={
            reservType &&
            typeof reservType === "object" &&
            Object.keys(reservType).length > 0
              ? reservType?.name
              : "Type"
          }
          onClick={() => setIsReservationType(!isReservationType)}
          ref={reservationType}
          disabled={!selectedDate}
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
        />
        <ReservationType
          isOpen={isReservationType}
          handleClose={() => setIsReservationType(false)}
          Ref={reservationType.current}
          isLoading={reservTypeLoading}
          Id={id}
        />
      </Grid>
      {reservType?.isPriceBasedOnDuration && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectComponent
            label={languageWords?.duration || "Duration"}
            value={
              activityDuration
                ? `${formatName(
                    activityDuration?.name,
                    languageWords
                  )}-  €${format_Number(activityDuration?.price)}`
                : "HH:MM"
            }
            onClick={() => setIsActivityDuration(!isActivityDuration)}
            ref={activityDurationRef}
            disabled={
              !selectedDate ||
              !(
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0
              )
            }
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
          />
          <TimeComponent
            isOpen={isActivityDuration}
            handleClose={() => setIsActivityDuration(false)}
            Ref={activityDurationRef.current}
            isDuration={true}
          />
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.Time}
          value={time?.trim() != "" ? time?.substring(0, 5) : "HH:MM"}
          onClick={() => setIsTimeComponent(!isTimeComponent)}
          ref={timeRef}
          disabled={
            !(
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0
            ) ||
            (!activityDuration && reservType?.isPriceBasedOnDuration)
          }
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
        />
        <TimeComponent
          isOpen={isTimeComponent}
          handleClose={() => setIsTimeComponent(false)}
          Ref={timeRef.current}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            height: "70px",
            backgroundColor:
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              selectedDate?.trim() != "" &&
              time?.trim() != ""
                ? theme?.widget?.bookNowbtnBgActive
                : theme?.widget?.bookNowBtnBg,
            color:
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              selectedDate?.trim() != "" &&
              time?.trim() != ""
                ? theme?.widget?.booknowBtnTextColorActive
                : theme?.widget?.booknowBtnTextColor,
            fontWeight: "bold",
            display: "flex", // Ensure flexbox is used
            flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
            justifyContent: "center", // Center the text vertically
            alignItems: "center", // Center the text horizontally
          }}
          onClick={() => {
            if (
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              // selectedDate &&
              time
            ) {
              navigate(`/bookNowActivity`);
            } else {
              return;
            }
          }}
        >
          {languageWords?.Booknow}
          {reservType?.products?.price > 0 && (
            <Box component="span" fontSize="13px" fontWeight="200">
              €{reservType?.products?.price}
            </Box>
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ActivityComponent;
